export default __webpack_public_path__ + "static/media/profile_pic.d92f35f8.jpg";